var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormControl, InputLabel, MenuItem, Select, Box } from '@mui/material';
var FilterBar = function (_a) {
    var _b = _a.label, label = _b === void 0 ? "Filter" : _b, _c = _a.width, width = _c === void 0 ? 180 : _c, value = _a.value, list = _a.list, onChange = _a.onChange;
    var id = label.replace(/\s/g, '') + '-filter' + Math.random().toString(36).substring(7);
    var handleChange = function (event) {
        onChange(event.target.value);
    };
    return (_jsx(Box, __assign({ width: width }, { children: _jsxs(FormControl, __assign({ size: 'small', fullWidth: true }, { children: [_jsx(InputLabel, __assign({ id: id }, { children: label })), _jsx(Select, __assign({ labelId: id, value: value, label: label, onChange: handleChange, sx: { textAlign: 'left' } }, { children: list.map(function (item) { return (_jsx(MenuItem, __assign({ value: item }, { children: item }), item)); }) }))] })) })));
};
export default FilterBar;
